import { createId } from '../utils/IdGenerator';
import { IListItemType } from './types';
/**
 * Generate a new item with temporary id and isNew flag.
 */
export function generateItem(): IListItemType {
  return {
    id: createId('new-list-item'),
    isNew: true,
    value: ''
  };
}
